import styled from 'styled-components'

import { breakpoints } from '@/styles'
import { isEmptyOrNull } from '@/utils'
import useSessionComplete from '@/hooks/use-session-complete'
import { useListImpressionTracking } from '@/components/ImpressionProvider/useListImpressionTracking'
import ListingCard from '@/components/listing-card'
import LockedListingCard from '@/components/listing-card/locked-listing-card'
import { useTermsDialogContext } from '@/components/terms-dialog/context'

import { IMPORTED_LISTING_PLATFORM } from '../ListingDetail/page'
import { MessageModalProvider } from '../ListingsMap/map-list/context'

const Wrapper = styled.div`
  margin: 24px auto 100px;
`

const GridWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 20px;
  justify-content: center;
  align-content: start;

  @media screen and (max-width: ${breakpoints.desktop}) {
    grid-template-columns: repeat(auto-fill, 350px);
  }

  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    grid-template-columns: repeat(auto-fill, 100%);
    justify-content: start;
    padding-left: 20px;
    padding-right: 20px;
  }
`

const SkeletonState = () => {
  return (
    <Wrapper>
      <GridWrapper>
        <ListingCard skeleton />
        <ListingCard skeleton />
        <ListingCard skeleton />
        <ListingCard skeleton />
        <ListingCard skeleton />
        <ListingCard skeleton />
      </GridWrapper>
    </Wrapper>
  )
}

const CardList = ({
  children = null,
  listings = [],
  noSchema,
  loading = false
}) => {
  const isLoggedIn = useSessionComplete()
  const { checkAgreementMismatch, isLoading } = useTermsDialogContext()
  const isAgreementMismatched = checkAgreementMismatch('trreb_agreements')
  const isAgreementLoading = isLoading && isLoggedIn
  useListImpressionTracking({ id: 'similar-listings', minVisibleDuration: 0 })

  if (loading && isEmptyOrNull(listings)) return <SkeletonState />
  return (
    <Wrapper data-impression-container="true">
      <GridWrapper>
        <MessageModalProvider>
          {children}
          {listings.map(listing => {
            const isImported = listing?.tags?.some(tag =>
              IMPORTED_LISTING_PLATFORM.includes(tag)
            )

            const isListingLocked =
              isImported &&
              (!isLoggedIn || isAgreementMismatched || isAgreementLoading)

            return isListingLocked ? (
              <LockedListingCard
                listing={listing}
                key={listing.listing_id}
                noSchema={noSchema}
                favouriteButton
              />
            ) : (
              <ListingCard
                listing={listing}
                key={listing.listing_id}
                favouriteButton
                noSchema={noSchema}
                trackImpression={{
                  enabled: true,
                  page: 'listing-detail',
                  section: 'similar-listings',
                  sponsored: false
                }}
              />
            )
          })}
        </MessageModalProvider>
      </GridWrapper>
    </Wrapper>
  )
}

export default CardList
